import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import * as Actions from './actions';

export default handleActions(
    {
        [Actions.fetch.type]: () => new Map(),
        [Actions.fetchSuccess.type]: (state, {payload}) =>
            Map(payload.statuses.map(status => [status.statusConfigId, status])),
        [Actions.createSuccess.type]: (state, {payload}) => state.set(payload.status.statusConfigId, payload.status),
        [Actions.updateSuccess.type]: (state, {payload}) =>
            state.update(payload.status.statusConfigId, () => payload.status),
        [Actions.remove.type]: (state, {payload}) =>
            state.update(payload.statusConfigId, status => status.merge({deleting: true})),
        [Actions.removeFailed.type]: (state, {payload}) =>
            state.update(payload.statusConfigId, status => status.merge({deleting: false})),
        [Actions.removeSuccess.type]: (state, {payload}) => state.delete(payload.statusConfigId),
        [Actions.applyStatus.type]: (state, {payload}) =>
            state.update(payload.statusConfigId, status => status.merge({loading: true})),
        [Actions.applyStatusSuccess.type]: (state, {payload}) =>
            state.update(payload.statusConfigId, status => status.merge({loading: false})),
        [Actions.applyStatusFailed.type]: (state, {payload}) =>
            state.update(payload.statusConfigId, status => status.merge({loading: false})),
        [Actions.endStatus.type]: (state, {payload}) =>
            state.update(payload.statusConfigId, status => status.merge({loading: true})),
        [Actions.endStatusSuccess.type]: (state, {payload}) =>
            state.update(payload.statusConfigId, status => status.merge({loading: false})),
        [Actions.endStatusFailed.type]: (state, {payload}) =>
            state.update(payload.statusConfigId, status => status && status.merge({loading: false})),
    },
    Map(),
);
